module.exports = __webpack_public_path__ + "static/media/footer_cart_black.11a66d53.png";